import { ChangeCartDeliveryAddressResult } from '../../../graphql/cart/changeCartDeliveryAddress';
import { ChangeDeliveryAddressPayload } from '@spa/lib/store/carts/cartsSlice';
import { CustomOrderType } from '../../carts/CustomOrderType';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartChangeCartDeliveryAddressRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly deliveryAddress: ChangeDeliveryAddressPayload;
  readonly parentActionId: number;
}
export const apiCartChangeCartDeliveryAddressRequestedType =
  'api/cart/changeCartDeliveryAddress--requested';
export const apiCartChangeCartDeliveryAddressRequested =
  createAction<ApiCartChangeCartDeliveryAddressRequestedPayload>(
    apiCartChangeCartDeliveryAddressRequestedType
  );
export type ApiCartChangeCartDeliveryAddressRequestedAction = ReturnType<
  typeof apiCartChangeCartDeliveryAddressRequested
>;

export interface ApiCartChangeCartDeliveryAddressSucceededPayload {
  readonly cartId: string;
  readonly result: ChangeCartDeliveryAddressResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}
export const apiCartChangeCartDeliveryAddressSucceededType =
  'api/cart/changeCartDeliveryAddress--succeeded';
export const apiCartChangeCartDeliveryAddressSucceeded =
  createAction<ApiCartChangeCartDeliveryAddressSucceededPayload>(
    apiCartChangeCartDeliveryAddressSucceededType
  );
export type ApiCartChangeCartDeliveryAddressSucceededAction = ReturnType<
  typeof apiCartChangeCartDeliveryAddressSucceeded
>;

export interface ApiCartChangeCartDeliveryAddressFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}
export const apiCartChangeCartDeliveryAddressFailedType =
  'api/cart/changeCartDeliveryAddress--failed';
export const apiCartChangeCartDeliveryAddressFailed =
  createAction<ApiCartChangeCartDeliveryAddressFailedPayload>(
    apiCartChangeCartDeliveryAddressFailedType
  );
export type ApiCartChangeCartDeliveryAddressFailedAction = ReturnType<
  typeof apiCartChangeCartDeliveryAddressFailed
>;
